import { actions } from '@app/store/action/transfer';

export default function (state = {}, action) {
  const { type } = action;

  switch (type) {
    case actions.DOWNLOAD_PENDING:
      return {
        ...state,
        isPending: true,
      };

    case actions.DOWNLOAD_SUCCESS:
      return {
        ...state,
        isPending: false,
      };

    case actions.DOWNLOAD_ERROR:
      return {
        ...state,
        isPending: false,
      };
  }

  return state;
}
